// Copyright (c) 2020 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import fetchUserDetails from "./fetchUserDetails"
import getSite from "./getSite"
import listNotifications from "./listNotifications"
import ackNotification from "./ackNotification"
import loadCurrentSiteId from "./loadCurrentSiteId"
import logOut from "./logOut"
import persistCurrentSiteId from "./persistCurrentSiteId"
import redirectToAddTeam from "./redirectToAddTeam"
import setUpTimeZone from "./setUpTimeZone"
import redirectToUrl from "./redirectToUrl"
import listSitePermissions from "./listSitePermissions"
import listUserTimelineMessages from "./listUserTimelineMessages"
import getTeam from "./getTeam"
import { Action } from "redux"
import type { RootState } from "../../../app/store"

export default combineEpics<Action, Action, RootState, unknown>(
  fetchUserDetails,
  getSite,
  listNotifications,
  ackNotification,
  loadCurrentSiteId,
  logOut,
  persistCurrentSiteId,
  redirectToAddTeam,
  setUpTimeZone,
  redirectToUrl,
  listSitePermissions,
  listUserTimelineMessages,
  getTeam,
)
